module.exports = __webpack_public_path__ + "static/media/tutorial-step-2.1d32937b.png";